import { render, staticRenderFns } from "./FuelConsumption.vue?vue&type=template&id=2f61bdb6"
import script from "./FuelConsumption.vue?vue&type=script&lang=js"
export * from "./FuelConsumption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f61bdb6')) {
      api.createRecord('2f61bdb6', component.options)
    } else {
      api.reload('2f61bdb6', component.options)
    }
    module.hot.accept("./FuelConsumption.vue?vue&type=template&id=2f61bdb6", function () {
      api.rerender('2f61bdb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApparatusDetails/FuelConsumption.vue"
export default component.exports